class URLResolver {
  private searchParams = new URLSearchParams(window.location.search);

  public parseUrlSearchParams = <ExpectedType, ResultType = ExpectedType | undefined>(name: string): ResultType => (
    this.searchParams.get(name) as unknown as ResultType
  );
}

export default URLResolver;
